import MUIMenuItem from '@mui/material/MenuItem'

export const MenuItem = MUIMenuItem
